export const REQUEST_MASTER_SUB_SERVICES = "REQUEST_MASTER_SUB_SERVICES";
export const SET_MASTER_SUB_SERVICES = "SET_MASTER_SUB_SERVICES";
export const ERROR_GET_MASTER_SUB_SERVICES = "ERROR_GET_MASTER_SUB_SERVICES";

export const REQUEST_CREATE_MASTER_SUB_SERVICES = "REQUEST_CREATE_MASTER_SUB_SERVICES";
export const SUCCESS_CREATE_MASTER_SUB_SERVICES = "SUCCESS_CREATE_MASTER_SUB_SERVICES";
export const ERROR_CREATE_MASTER_SUB_SERVICES = "ERROR_CREATE_MASTER_SUB_SERVICES";

export const REQUEST_UPDATE_MASTER_SUB_SERVICES = "REQUEST_UPDATE_MASTER_SUB_SERVICES";
export const SUCCESS_UPDATE_MASTER_SUB_SERVICES = "SUCCESS_UPDATE_MASTER_SUB_SERVICES";
export const ERROR_UPDATE_MASTER_SUB_SERVICES = "ERROR_UPDATE_MASTER_SUB_SERVICES";

export const REQUEST_DELETE_MASTER_SUB_SERVICES = "REQUEST_DELETE_MASTER_SUB_SERVICES";
export const SUCCESS_DELETE_MASTER_SUB_SERVICES = "SUCCESS_DELETE_MASTER_SUB_SERVICES";
export const ERROR_DELETE_MASTER_SUB_SERVICES = "ERROR_DELETE_MASTER_SUB_SERVICES";

export const SET_MESSAGE_MASTER_SUB_SERVICES = "SET_MESSAGE_MASTER_SUB_SERVICES";